import i18n from 'i18next';
import { flexflowApi } from 'src/old/api/flexflow/flexflow.api';
import { type CategoriesLimits } from 'src/old/api/flexflow/types';
import { addToast } from 'src/old/actions/toasts/toastsActions';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import { actionSuccess } from 'src/old/actions/utils';
import { type AppDispatch } from 'src/store';
import { api, zeusApi } from 'src/store/api';

export const PUT_FLEXFLOW_CATEGORY_LIMITS = 'PUT_FLEXFLOW_CATEGORY_LIMITS';

export const putFlexflowCategoryLimits =
  (employeeId: number, limits: CategoriesLimits) =>
  async (dispatch: AppDispatch): Promise<boolean> => {
    try {
      await flexflowApi.putCategoryLimits(employeeId, limits);

      dispatch(
        actionSuccess(PUT_FLEXFLOW_CATEGORY_LIMITS, {
          limits,
          employeeId
        })
      );

      // Invalidate open employee data and flexflow table data
      dispatch(api.util.invalidateTags(['Flexflow']));
      dispatch(zeusApi.util.invalidateTags(['Flexflow']));

      dispatch(
        addToast({
          ...toastTypes.success,
          defaultMessage: i18n.t('flexflow.card.put.success', {
            ns: ['actions']
          })
        })
      );

      return true;
    } catch (error: any) {
      dispatch(
        addToast(
          {
            ...toastTypes.error,
            defaultMessage: i18n.t('flexflow.card.put.error', {
              ns: ['actions']
            })
          },
          error
        )
      );
      return false;
    }
  };
